import { Button } from '@pocketlaw/tetris';
import { useGetLinks } from 'shared/domains/urls';
export function CtaButton(props) {
    const { children } = props;
    const { contact } = useGetLinks();
    return (<Button as="a" href={contact} target="_blank" rel="noopener noreferrer" $stretch appearance="primary" size="small">
      {children}
    </Button>);
}
